/*
 * Copyright (c) Ekathva Innovations Private Limited- All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * Proprietary and confidential
 *
 * Author: Nikitha S Bhatt (nikitha@ekathvainnovations.com), Akshay K Kulkarni (akshay.kulkarni@ekathvainnovations.com)
 *
 * Date:08-06-2021
 *
 * Filename: OurClientsPage
 * Page name: our-clients
 * Page Description: This is the clients page of the website of Ekathva Innovations.
 */

import React, { useEffect } from 'react'
import MetaTags from 'react-meta-tags'
import { Row, Col } from 'react-bootstrap'
import Navbar from 'components/Navbars/Navbar'
import LandingPageMedia from 'components/Headers/LandingPageClients'
import Footer from 'components/Footers/Footer'

import 'assets/style/Style.css'

import AMST from "assets/images/Clients/PNG/Amst.png"
import Vtech from "assets/images/Clients/PNG/Vtech.png"
import Ibbani from "assets/images/Clients/PNG/Ibbani.png"
import Vaml from "assets/images/Clients/PNG/Vaml.png"
import Vfb from "assets/images/Clients/PNG/Vfb.png"

import Kipl from "assets/images/Clients/PNG/Kipl.png"
import Sgb from "assets/images/Clients/PNG/Sgb.png"
import Sumukha from "assets/images/Clients/PNG/Sumukha.png"
import Techno from "assets/images/Clients/PNG/Techno.png"

import Uahs from "assets/images/Clients/PNG/Uahs.png"
import Nes from "assets/images/Clients/PNG/Nes.png"
import Jnnce from "assets/images/Clients/PNG/Jnnce.png"
import Gfgc from "assets/images/Clients/PNG/Gfgc.png"

import Vishwa from "assets/images/Clients/PNG/Vishwa.png"
import Amst from "assets/images/Clients/PNG/Amst.png"
import Clinical from "assets/images/Clients/PNG/Clinical.png"
import Glwc from "assets/images/Clients/PNG/Glwc.png"

import Supari from "assets/images/Clients/PNG/Supari.png"
import Malnadkitchen from "assets/images/Clients/PNG/Malnadkitchen.png"
import MrMillet from "assets/images/Clients/PNG/MrMillet.jpeg"
import Rootsgoods from "assets/images/Clients/PNG/Rootsgoods.png"

import Nano from "assets/images/Clients/PNG/Nano.png"
import Arshiraj from "assets/images/Clients/PNG/Arshiraj.png"
import Benz from "assets/images/Clients/PNG/Benz.png"
import Church from "assets/images/Clients/PNG/Church.png"

import Monica from "assets/images/Clients/PNG/Monica.png"
import Pgp from "assets/images/Clients/PNG/Pgp.png"
import Scholar from "assets/images/Clients/PNG/Scholar.png"
import Cedlabs from "assets/images/Clients/PNG/Cedlabs.png"

import Souparnika from 'assets/images/Clients/Souparnika.jpg'

function OurClients() {

  useEffect( () => {
      window.scrollTo(0, 0)
  }, [])

    return (
    <div>
        <MetaTags>
            <title>Our Privileged Clients - Clients we work with | Ekathva Innovations Pvt</title>
            <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
        </MetaTags>

        <Navbar/>
        <LandingPageMedia/>
        <br/>

        <div className='ourclients_spacing' >
            <Row>
                <Col>
                    <a href='http://www.vtechengineer.com/' target='_blank' >
                        <img src={Vtech} alt="V-Tech Engineers Logo" className='ourclients_imagestyling'/>
                    </a>
                    <br/> <strong className='ourclients_vtechnaming' >V-Tech Engineers</strong>
                </Col>

                <Col>
                    <a href='http://www.ibbanifoods.com/' target='_blank'>
                       <img src={Ibbani} alt="Ibbani Food Industries Logo" className='ourclients_imagestyling' />
                    </a>
                    <br/> <strong className='ourclients_ibbaninaming' >Ibbani Food Industries</strong>
                </Col>

                <Col>
                    <a href='http://www.vishwabhushanatrust.org/' target='_blank'>
                        <img src={Vishwa} alt="Vishwabhushana Trust Logo" className='ourclients_imagestyling' />
                    </a>
                    <br/> <strong className='ourclients_ibbaninaming' >Vishwabhushana Trust</strong>
                </Col>

                <Col>
                    <img src={Scholar} alt="Scholar Monk Foundation Logo" className='ourclients_imagestyling' />
                    <br/> <strong className='ourclients_scholarnaming' >Scholar Monks Foundation</strong>
                </Col>
            </Row>
            <hr/>
            <Row>
                <Col>
                    <a href='http://www.sumukasteels.com/' target='_blank'>
                        <img src={Sumukha} alt="Sumuka Steels Logo" className='ourclients_imagestyling' />
                    </a>
                    <br/> <strong className='ourclients_scholarnaming' >Sumuka Steels Pvt Ltd</strong></Col>
                <Col>
                    <a href='http://www.monicakulkarni.com/' target='_blank'>
                        <img src={Monica} alt="Monica Kulkarni Logo" className='ourclients_imagestyling' />
                    </a>
                    <br/> <strong className='ourclients_monicanaming' >Monica Kulkarni</strong></Col>
                <Col>
                    <a href='https://www.rootsgoods.com/' target='_blank'>
                        <img src={Rootsgoods} alt="RootsGoods Logo" className='ourclients_imagestyling' />
                    </a>
                    <br/>
                    <strong className='ourclients_scholarnaming' >RootsGoods OPC Pvt Ltd</strong></Col>
                <Col>
                <img src={AMST} alt="AMST Conference Logo" className='ourclients_imagestyling' />
                <br/>
                 <strong className='ourclients_ibbaninaming' >AMST Conference 2020</strong></Col>
            </Row>
            <hr/>
            <Row>
                <Col>
                    <a href='http://gfgckalasa.edu.in/' target='_blank'>
                        <img src={Gfgc} alt="Govt First Grade College, Kalasa" className='ourclients_imagestyling' />
                    </a>
                    <br/>
                    <strong className='ourclients_scholarnaming' >Government First Grade <br/> College, Kalasa</strong>
                </Col>

                <Col>
                    <img src={Church} alt=" St Thomas Church Logo" className='ourclients_imagestyling' />
                    <br/> <strong className='ourclients_scholarnaming' >CSI St. Thomas Church</strong>
                </Col>

                <Col>
                    <a href="https://www.kvafsu.edu.in/vch_bengaluru.html" target="_blank">
                        <img src={Clinical} alt="Veterinary college Logo" className='ourclients_imagestyling' />
                    </a>
                    <br/> <strong className='ourclients_vetnaming' >Veterinary College</strong>
                </Col>

                <Col>
                <a href="http://www.nes-shimoga.org/" target="_blank">
                    <img src={Nes} alt="National Education Society Logo" className='ourclients_imagestyling' />
                </a>
                    <br/> <strong className='ourclients_scholarnaming' >National Eductaion Society</strong>
                </Col>
            </Row>
            <hr/>
            <Row>
                <Col>
                <a href="http://jnnce.ac.in/jnndemo/" target="_blank">
                    <img src={Jnnce} alt=" JNN College of Engineering Logo" className='ourclients_imagestyling' />
                </a>
                    <br/> <strong className='ourclients_scholarnaming' >JNN College of Engineering</strong>
                </Col>

                <Col>
                <a href="https://www.mbrdi.co.in/" target="_blank">
                    <img src={Benz} alt="Mercedes Benz Logo" className='ourclients_imagestyling' />
                </a>
                    <br/> <strong className='ourclients_monicanaming' >Mercedes-Benz</strong>
                </Col>

                <Col>
                <a href="https://nanosourcetechnology.com/index.php" target="_blank">
                    <img src={Nano} alt=" Nano Source Technologies Logo" className='ourclients_imagestyling' />
                </a>
                    <br/> <strong className='ourclients_scholarnaming' >Nano Source Technology</strong>
                </Col>

                <Col>
                    <a href="https://www.technorings.in/" target="_blank">
                        <img src={Techno} alt="Technorings Logo" className='ourclients_imagestyling' />
                    </a>
                    <br/> <strong className='ourclients_nanonaming' >Techno Rings</strong>
                </Col>
            </Row>
            <hr/>
            <Row>
                <Col>
                    <a href="https://uahs.edu.in/" target="_blank">
                        <img src={Uahs} alt="University of Agriculture and Horticulture Sciences Logo" className='ourclients_imagestyling' />
                    </a>
                    <br/> <strong className='ourclients_scholarnaming' >University of Agriculture<br/> and Horticultural Sciences</strong>
                </Col>

                <Col>
                    <a href="http://www.sgb.net.in/" target="_blank">
                        <img src={Sgb} alt="Sri Gowri Bhargava Private Limited Logo" className='ourclients_imagestyling' />
                    </a>
                    <br/> <strong className='ourclients_scholarnaming' >Sri Gowri Bhargava Private<br/> Limited</strong>
                </Col>

                <Col>
                    <img src={Vfb} alt="V-Tech Food and Beverages Logo" className='ourclients_imagestyling' />
                    <br/> <strong className='ourclients_scholarnaming' >V-Tech Food and Beverages</strong>
                </Col>

                <Col>
                    <img src={Kipl} alt="Kuntvalli Industries Private Limited Logo" className='ourclients_imagestyling' />
                    <br/> <strong className='ourclients_scholarnaming' >Kuntvalli Inddustries Pvt Ltd</strong>
                </Col>
            </Row>
            <hr/>
            <Row>
                <Col>
                    <a href="http://www.cedlabs.in/" target="_blank">
                        <img src={Cedlabs} alt="CED Labs Logo" className='ourclients_imagestyling' />
                    </a>
                    <br/> <strong className='ourclients_milletnaming' >CED Labs</strong>
                </Col>

                <Col>
                    <a href="https://www.malnadkitchen.com/" target="_blank">
                        <img src={Malnadkitchen} alt="Malnad Kitchen Logo" className='ourclients_imagestyling' />
                    </a>
                    <br/> <strong className='ourclients_vetnaming' >Malnad Kitchen</strong>
                </Col>

                <Col>
                    <img src={Supari} alt="Natural Supari Logo" className='ourclients_imagestyling' />
                    <br/> <strong className='ourclients_suparinaming' >Natural Supari</strong>
                </Col>

                <Col>
                    <img src={Pgp} alt="PG Prashanth Physics Channel Logo" className='ourclients_imagestyling' />
                    <br/> <strong className='ourclients_scholarnaming' >Physics Gyan by Prashanth</strong>
                </Col>
            </Row>
            <hr/>
            <Row>
                <Col>
                    <a href="https://glwc-kar.org/" target="_blank">
                        <img src={Glwc} alt="Rajya Sarkari Padavi Collegegala Atithi Upanyasakara Hitarakshana Samithi Logo" className='ourclients_imagestyling' />
                    </a>
                    <br/> <strong className='ourclients_scholarnaming' >Rajya Sarkari Padavi Collegegala<br/> Atithi Upanyasakara Hitarakshana<br/> Samithi</strong>
                </Col>

                <Col>
                    <a href="https://www.vaml.in/" target="_blank">
                        <img src={Vaml} alt="V-Tech Automotors Limited Logo" className='ourclients_imagestyling' />
                    </a>
                    <br/> <strong className='ourclients_vamlnaming' >V-Tech Automotors Ltd</strong>
                </Col>

                <Col>
                    <img src={MrMillet} alt="Mr Millet Logo" className='ourclients_imagestyling' />
                    <br/> <strong className='ourclients_milletnaming' >Mr Millet</strong>
                </Col>

                <Col>
                    <img src={Souparnika} alt="Souparnika Ayurvedalaya Logo" className="ourclients_imagestyling"/>
                    <br/> <strong className='ourclients_souparnikanaming' >Souparnika Ayurveedalaya</strong>
                </Col>
            </Row>
            <br/>
        </div>
        <Footer/>
    </div>
    )
}

export default OurClients
